export const IS_SHOW_COLORS_EDIT_TOOLTIP_LOCALSTORAGE = 'IS_SHOW_COLORS_EDIT_TOOLTIP_LOCALSTORAGE';
